import React from 'react';

interface ProductAdvertenceProps {
  /** Array of advertence strings from characteristic id 10 valueJson */
  advertences: string[];
}

const ProductAdvertence: React.FC<ProductAdvertenceProps> = ({
  advertences,
}) => {
  if (!advertences?.length) {
    return null;
  }

  const validAdvertences = advertences.filter(
    (text) => typeof text === 'string' && text.trim().length > 0,
  );

  if (validAdvertences.length === 0) {
    return null;
  }

  return (
    <div className="mt-5 mb-3 w-full">
      <ul className="list-none p-0 space-y-3 w-full">
        {validAdvertences.map((text, index) => (
          <li
            className="rounded-lg border border-black p-2 text-gray-800 w-full box-border text-xs font-semibold text-justify leading-relaxed"
            role="alert"
            aria-live="polite"
            key={index}
          >
            {text.trim().toUpperCase()}
          </li>
        ))}
      </ul>

    </div>
  );
};

export default ProductAdvertence;
